/* =========================================================
   MF Product page — assets/mf-product.js
   Gallery (loop, long-press save) + lightbox, wishlist + share, offers pop-up,
   Style/Size variant logic (hidden Color), custom-size pop-up, add-ons,
   sticky bar, delivery checker, reviews link, size chart.
   Add to cart is done by the header (AJAX) through form.mfValidate / form.mfPrepare.
   Gallery fix: swipe direction follows the finger; videos open in the full-screen viewer.
   ========================================================= */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var STORE_KEY = 'mf_measurements_v1';
  var POST_KEY = 'mf_last_postcode';
  var WISH_KEY = 'mf_wishlist';

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function behavior() { return RM.matches ? 'auto' : 'smooth'; }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function inView(el) { var r = el.getBoundingClientRect(); return r.top >= 0 && r.bottom <= window.innerHeight; }
  function isRtl(el) { return getComputedStyle(el).direction === 'rtl'; }

  /* ================= Scroll lock (shared by all pop-ups) ================= */
  // Only a class on <html> (overflow hidden) + scrollbar compensation. Never touches font-size,
  // position or width. The exact previous body padding and scroll position are restored.
  var locks = 0, saved = null;
  function lock() {
    if (locks++ > 0) return;
    var sw = window.innerWidth - document.documentElement.clientWidth;
    saved = { y: window.pageYOffset, pr: document.body.style.paddingRight };
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    document.documentElement.classList.add('mf-scroll-lock');
  }
  function unlock() {
    if (!locks) return;
    if (--locks > 0) return;
    document.documentElement.classList.remove('mf-scroll-lock');
    if (saved) {
      document.body.style.paddingRight = saved.pr;
      if (Math.abs(window.pageYOffset - saved.y) > 1) window.scrollTo(0, saved.y);
      saved = null;
    }
  }

  /* ================= Sheet: bottom sheet on mobile / centred modal on desktop =================
     Native <dialog>.showModal(): focus stays inside, the page behind is inert, Esc closes. */
  function Sheet(dlg, opts) {
    opts = opts || {};
    var opener = null, closing = false;
    function open(trigger) {
      if (!dlg || dlg.open) return;
      opener = trigger || document.activeElement;
      dlg.showModal();
      lock();
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      var f = opts.focus ? opts.focus() : $(dlg, '.mf-sheet__x');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 40);
      if (opts.onOpen) opts.onOpen();
    }
    function close() {
      if (!dlg || !dlg.open || closing) return;
      closing = true;
      dlg.classList.remove('is-open');
      setTimeout(function () {
        closing = false;
        dlg.close(); unlock();
        if (opener && opener.focus) opener.focus({ preventScroll: true });
        if (opts.onClose) opts.onClose();
      }, RM.matches ? 0 : 230);
    }
    if (dlg) {
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });         // Esc
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });        // overlay
      $$(dlg, '[data-mf-sheet-close]').forEach(function (b) { b.addEventListener('click', close); });
    }
    return { open: open, close: close, el: dlg };
  }

  /* ================= Slider engine (gallery + lightbox) =================
     Transform-based (no native scrolling), so the loop is seamless: a copy of the last slide sits
     before the first and a copy of the first after the last. Swiping past the end animates onto the
     copy exactly like any other slide, then the track silently swaps to the real slide (same pixels,
     no visible change). Vertical page scrolling stays native (touch-action: pan-y). */
  function Slider(track, opts) {
    opts = opts || {};
    var real = Array.prototype.slice.call(track.children);
    var n = real.length, loop = !!opts.loop && n > 1;
    function clone(src) {
      var c = src.cloneNode(true);
      c.classList.add('is-clone'); c.classList.remove('is-active', 'product__media-item');
      c.setAttribute('aria-hidden', 'true'); c.removeAttribute('aria-label');
      if ('inert' in c) c.inert = true;
      $$(c, '[id]').forEach(function (el) { el.removeAttribute('id'); });
      $$(c, 'img').forEach(function (im) { im.removeAttribute('fetchpriority'); });
      $$(c, 'video').forEach(function (v) { v.preload = 'none'; v.removeAttribute('autoplay'); });
      $$(c, 'iframe').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
      $$(c, '[tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      return c;
    }
    if (loop) { track.insertBefore(clone(real[n - 1]), real[0]); track.appendChild(clone(real[0])); }
    var all = Array.prototype.slice.call(track.children);
    var d = loop ? 1 : 0, x = 0, moving = false;
    var dur = 340;

    function realIndex(i) { if (!loop) return i; if (i === 0) return n - 1; if (i === n + 1) return 0; return i - 1; }
    function domIndex(r) { return loop ? r + 1 : r; }
    function pos(i) { return all[i].offsetLeft - all[0].offsetLeft; }
    function setX(v, anim) {
      var a = anim && !RM.matches;
      track.style.transition = a ? 'transform ' + dur + 'ms cubic-bezier(.22,.8,.24,1)' : 'none';
      track.style.transform = 'translate3d(' + (-v) + 'px,0,0)';
      x = v; moving = a;
    }
    function preload(i) {   // make sure the visible slide and its neighbours are loaded (no blank flash)
      [i - 1, i, i + 1, i + 2].forEach(function (k) {
        var sl = all[k]; if (!sl) return;
        $$(sl, 'img').forEach(function (im) {
          if (im.getAttribute('data-src')) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
          if (im.loading === 'lazy') im.loading = 'eager';
        });
      });
    }
    function normalize() {    // landed on a copy -> jump to the real slide (identical image, invisible swap)
      moving = false;
      if (!loop) return;
      if (d === 0) { d = n; setX(pos(d), false); }
      else if (d === n + 1) { d = 1; setX(pos(d), false); }
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track && e.propertyName === 'transform') normalize(); });

    function go(i, anim) {
      if (n < 2) { setX(0, false); return; }
      if (moving) normalize();                 // finish a pending wrap before starting a new move
      if (loop) i = Math.max(0, Math.min(n + 1, i)); else i = Math.max(0, Math.min(n - 1, i));
      d = i;
      preload(d);
      setX(pos(d), anim !== false);
      if (anim === false || RM.matches) normalize();
      if (opts.onChange) opts.onChange(realIndex(d));
    }
    function next() { if (!loop && d >= n - 1) return go(0); go(d + 1); }
    function prev() { if (!loop && d <= 0) return go(n - 1); go(d - 1); }

    // ---- touch / mouse drag ----
    var p = null, suppress = false;
    track.addEventListener('pointerdown', function (e) {
      if (n < 2 || !e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (opts.canDrag && !opts.canDrag(e)) return;
      if (moving) normalize();
      p = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x0: x, decided: false, h: false, lastX: e.clientX, lastT: performance.now(), v: 0 };
    });
    track.addEventListener('pointermove', function (e) {
      if (!p || e.pointerId !== p.id) return;
      var dx = e.clientX - p.sx, dy = e.clientY - p.sy;
      if (!p.decided) {
        if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
        p.decided = true; p.h = Math.abs(dx) > Math.abs(dy);
        if (!p.h) { p = null; return; }       // vertical: let the page scroll
        try { track.setPointerCapture(p.id); } catch (err) {}
        track.classList.add('is-dragging');
      }
      e.preventDefault();
      var now = performance.now();
      p.v = (e.clientX - p.lastX) / Math.max(1, now - p.lastT); p.lastX = e.clientX; p.lastT = now;
      var v = p.x0 - dx;
      if (!loop) { var max = pos(n - 1); if (v < 0) v = v / 3; else if (v > max) v = max + (v - max) / 3; }
      setX(v, false);
    });
    function end(e) {
      if (!p || (e && e.pointerId !== p.id)) return;
      // pointercancel / lostpointercapture can report the finger at x = 0 on phones, which read as a
      // long right-to-left swipe (= next). Only pointerup has a reliable position; otherwise use the last move.
      var endX = (e && e.type === 'pointerup') ? e.clientX : p.lastX;
      var wasDrag = p.decided && p.h, dx = endX - p.sx, vel = p.v;
      p = null;
      track.classList.remove('is-dragging');
      if (!wasDrag) return;
      suppress = true; setTimeout(function () { suppress = false; }, 50);
      var w = all[d] ? all[d].offsetWidth : track.offsetWidth;
      var th = Math.min(80, w * 0.18);
      // Direction always follows the drag: right-to-left = next, left-to-right = previous.
      // A quick flick only counts in the same direction as the drag, so the small backwards
      // movement as the finger lifts can no longer turn a "previous" swipe into "next".
      if (dx <= -th || (dx < 0 && vel < -0.45)) go(d + 1);
      else if (dx >= th || (dx > 0 && vel > 0.45)) go(d - 1);
      else go(d);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', function (e) { if (p && e.pointerId === p.id) end(e); });
    track.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    window.addEventListener('resize', function () { if (moving) normalize(); setX(pos(d), false); });
    requestAnimationFrame(function () { setX(pos(d), false); preload(d); });

    return {
      go: function (r, anim) { go(domIndex(r), anim); },
      next: next, prev: prev,
      index: function () { return realIndex(d); },
      count: n, slides: real, refresh: function () { setX(pos(d), false); }
    };
  }

  /* ================= Gallery ================= */
  function Gallery(root, openLightbox) {
    var g = $(root, '[data-mf-gallery]');
    var api = { goToMedia: function () {} };
    if (!g) return api;
    var track = $(g, '[data-mf-track]');
    var thumbs = $$(g, '[data-mf-thumb]');
    var thumbBox = $(g, '[data-mf-thumbs]');
    var count = $(g, '[data-mf-count]');
    var prevBtn = $(g, '[data-mf-prev]'), nextBtn = $(g, '[data-mf-next]');
    var real = $$(track, '.mf-g__slide');
    var cur = -1;

    function setActive(i) {
      if (i === cur) return;
      cur = i;
      real.forEach(function (sl, j) {
        sl.classList.toggle('is-active', j === i);
        if (j !== i) { var v = sl.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
      thumbs.forEach(function (t, j) {
        if (j === i) {
          t.setAttribute('aria-current', 'true');
          if (thumbBox) {
            var tr = t.getBoundingClientRect(), br = thumbBox.getBoundingClientRect();
            if (thumbBox.scrollHeight > thumbBox.clientHeight + 2) thumbBox.scrollBy({ top: (tr.top - br.top) - (br.height - tr.height) / 2, behavior: behavior() });
            else thumbBox.scrollBy({ left: (tr.left - br.left) - (br.width - tr.width) / 2, behavior: behavior() });
          }
        } else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = String(i + 1);
    }
    var slider = Slider(track, { loop: true, onChange: setActive });
    setActive(0);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { slider.go(parseInt(t.getAttribute('data-mf-thumb'), 10)); });
      t.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step) return;
        e.preventDefault(); if (step > 0) slider.next(); else slider.prev();
        var nx = thumbs[slider.index()]; if (nx) nx.focus({ preventScroll: true });
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { slider.prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { slider.next(); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); slider.next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); slider.prev(); }
      else if (e.key === 'Home') { e.preventDefault(); slider.go(0); }
      else if (e.key === 'End') { e.preventDefault(); slider.go(slider.count - 1); }
      else if (e.key === 'Enter' || (e.key === ' ' && e.target === track)) {
        var o = real[slider.index()] && real[slider.index()].querySelector('[data-mf-open]');
        if (o) { e.preventDefault(); o.click(); }
      }
    });
    // Tap opens the lightbox (also on the peeking copies). Long-press is left to the browser.
    $$(track, '[data-mf-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.closest('.mf-g__slide');
        var lbi = li && li.getAttribute('data-lb-index');
        if (lbi != null && openLightbox) openLightbox(parseInt(lbi, 10), track);
      });
    });
    $$(track, 'img').forEach(function (im) { im.setAttribute('draggable', 'false'); });

    api.goToMedia = function (mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < real.length; i++) if (real[i].getAttribute('data-media-id') === String(mediaId)) { if (i !== slider.index()) slider.go(i); return; }
    };
    return api;
  }

  /* ================= Lightbox (same slider, loops too) ================= */
  function Lightbox(root) {
    var dlg = $(root, '[data-mf-lb]');
    if (!dlg || typeof dlg.showModal !== 'function') return null;
    var track = $(dlg, '[data-mf-lb-track]');
    var countEl = $(dlg, '[data-mf-lb-count]');
    var opener = null;
    function unzoom() {
      dlg.classList.remove('is-zoomed');
      $$(track, '.mf-lb__img.is-zoomed').forEach(function (im) { im.classList.remove('is-zoomed'); im.style.transformOrigin = ''; });
    }
    var shownIdx = -1;
    function pauseVideos() { $$(track, 'video').forEach(function (v) { if (!v.paused) v.pause(); }); }
    var slider = Slider(track, {
      loop: true,
      canDrag: function (e) {
        if (dlg.classList.contains('is-zoomed')) return false;
        // Videos: a drag that starts on the video's own play bar (bottom strip) is seeking, not a swipe
        var vid = e && e.target && e.target.closest ? e.target.closest('video') : null;
        if (vid && e.clientY > vid.getBoundingClientRect().bottom - 64) return false;
        return true;
      },
      onChange: function (i) {
        unzoom(); if (countEl) countEl.textContent = String(i + 1);
        if (i !== shownIdx) { pauseVideos(); shownIdx = i; }   // moving to another item stops a playing video
      }
    });
    track.addEventListener('click', function (e) {
      var img = e.target.closest('.mf-lb__img'); if (!img) return;
      var z = !img.classList.contains('is-zoomed');
      unzoom();
      if (z) {
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.classList.add('is-zoomed'); dlg.classList.add('is-zoomed');
      }
    });
    track.addEventListener('pointermove', function (e) {
      var img = e.target.closest('.mf-lb__img.is-zoomed'); if (!img) return;
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)) + '% ' +
        Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)) + '%';
    });
    var pb = $(dlg, '[data-mf-lb-prev]'), nb = $(dlg, '[data-mf-lb-next]');
    if (pb) pb.addEventListener('click', function () { slider.prev(); });
    if (nb) nb.addEventListener('click', function () { slider.next(); });
    $(dlg, '[data-mf-lb-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); slider.next(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); slider.prev(); }
    });
    dlg.addEventListener('close', function () { pauseVideos(); shownIdx = -1; unzoom(); unlock(); if (opener && opener.focus) opener.focus({ preventScroll: true }); });
    return function open(i, from) {
      opener = from || document.activeElement;
      dlg.showModal(); lock();
      requestAnimationFrame(function () { slider.refresh(); slider.go(i, false); });
    };
  }

  /* ================= Offers pop-up ================= */
  function Offers(root) {
    var dlg = $(root, '[data-mf-sheet="offers"]'); if (!dlg) return;
    var sheet = Sheet(dlg);
    $$(root, '[data-mf-sheet-open="offers"]').forEach(function (b) { b.addEventListener('click', function () { sheet.open(b); }); });
    $$(dlg, '[data-mf-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-mf-copy'), label = $(b, '[data-mf-copy-label]');
        copyText(code, function () {
          if (label) label.textContent = 'Copied \u2713';
          b.setAttribute('aria-label', 'Code ' + code + ' copied');
          setTimeout(function () { if (label) label.textContent = 'Copy'; b.setAttribute('aria-label', 'Copy code ' + code); }, 1600);
        });
      });
    });
  }
  function copyText(text, done) {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      (document.querySelector('dialog[open]') || document.body).appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      ta.remove();
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, fallback);
    else fallback();
  }

  /* ================= Wishlist (on-device list, header count) ================= */
  function Wishlist(root, D) {
    var btn = $(root, '[data-mf-wish]'); if (!btn) return;
    function list() { var l = lsGet(WISH_KEY); return Array.isArray(l) ? l : []; }
    function has() { return list().some(function (x) { return x && x.id === D.id; }); }
    function render() {
      var on = has();
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
    function broadcast(l) {
      if (window.MFHeader && typeof window.MFHeader.setWishlistCount === 'function') window.MFHeader.setWishlistCount(l.length);
      document.dispatchEvent(new CustomEvent('mf:wishlist:change', { detail: { productId: D.id, handle: D.handle, count: l.length, saved: has() } }));
    }
    btn.addEventListener('click', function () {
      var l = list(), on = has();
      if (on) l = l.filter(function (x) { return x && x.id !== D.id; });
      else {
        var price = $(root, '[data-mf-now]');
        l.unshift({ id: D.id, handle: D.handle, title: D.title, url: D.url, image: D.image, price: price ? price.textContent.trim() : '', added: Date.now() });
        l = l.slice(0, 100);
      }
      if (!lsSet(WISH_KEY, l)) {   // private mode / storage blocked: say so instead of failing silently
        btn.setAttribute('aria-label', 'Wishlist unavailable in this browser');
        btn.title = 'Your browser blocked saving the wishlist';
        return;
      }
      render(); broadcast(l);
      if (!on) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    });
    window.addEventListener('storage', function (e) { if (e.key === WISH_KEY) render(); });
    render();
  }

  /* ================= Share ================= */
  function Share(root, D) {
    var wrap = $(root, '[data-mf-share-wrap]'); if (!wrap) return;
    var btn = $(wrap, '[data-mf-share]'), pop = $(wrap, '.mf-share__pop');
    var copyBtn = $(wrap, '[data-mf-share-copy]'), copyLabel = $(wrap, '[data-mf-share-copy-label]');
    function close(refocus) { if (pop.hidden) return; pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (refocus) btn.focus(); }
    function open() { pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); var f = $(pop, '.mf-share__item'); if (f) f.focus(); }
    var touch = window.matchMedia('(pointer: coarse)').matches || MOBILE.matches;
    btn.addEventListener('click', function () {
      if (touch && navigator.share) {
        navigator.share({ title: D.title, url: D.url }).catch(function (err) { if (err && err.name !== 'AbortError') open(); });
        return;
      }
      if (pop.hidden) open(); else close(false);
    });
    copyBtn.addEventListener('click', function () {
      copyText(D.url, function () {
        copyLabel.textContent = 'Copied \u2713';
        setTimeout(function () { copyLabel.textContent = 'Copy link'; close(true); }, 1400);
      });
    });
    $(wrap, '[data-mf-share-wa]').addEventListener('click', function () { setTimeout(function () { close(false); }, 100); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(true); } });
  }

  /* ================= Reviews link ================= */
  function Reviews(root, selector) {
    $$(root, '[data-mf-reviews-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = null;
        try { target = document.querySelector(selector); } catch (err) {}
        if (!target) return; // fall back to #mf-reviews anchor
        e.preventDefault();
        var det = target.closest('details'); if (det) det.open = true;
        var tab = target.closest('[aria-expanded="false"]'); if (tab && tab.click) tab.click();
        target.scrollIntoView({ behavior: behavior(), block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        setTimeout(function () { target.focus({ preventScroll: true }); }, RM.matches ? 0 : 500);
      });
    });
  }

  /* ================= Size chart ================= */
  function SizeChart(root) {
    var d = $(root, '[data-mf-chart]'); if (!d || typeof d.showModal !== 'function') return;
    $$(root, '[data-mf-chart-open]').forEach(function (b) { b.addEventListener('click', function () { d.showModal(); }); });
    $(d, '[data-mf-chart-close]').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  }

  /* ================= Delivery checker =================
     ONE place to add countries: code -> { name, re, format, example, days, demonym }.
     days: 'uk' uses the UK range from the theme editor (7–12); 'intl' uses the other range (15–20).
     Input is trimmed + upper-cased before testing; `format` turns a valid value into its display form. */
  var UK_RE = /^(GIR ?0AA|(?:[A-PR-UWYZ](?:\d{1,2}|[A-HK-Y]\d{1,2}|\d[A-HJKPSTUW]|[A-HK-Y]\d[ABEHMNPRV-Y])) ?\d[ABD-HJLNP-UW-Z]{2})$/;
  var DELIVERY_COUNTRIES = {
    GB: { name: 'United Kingdom', label: 'UK postcode', example: 'SW1A 1AA', days: 'uk',
          test: function (v) { return UK_RE.test(v) || UK_RE.test(v.replace(/\s/g, '')); },
          format: function (v) { var c = v.replace(/\s/g, ''); return c.slice(0, -3) + ' ' + c.slice(-3); } },
    US: { name: 'United States', label: 'US ZIP code', example: '90210 or 90210-1234', days: 'intl',
          re: /^\d{5}(?:-\d{4})?$/ },
    NL: { name: 'Netherlands', label: 'Dutch postcode', example: '1234 AB', days: 'intl',
          re: /^\d{4} ?[A-Z]{2}$/,
          format: function (v) { var c = v.replace(/\s/g, ''); return c.slice(0, 4) + ' ' + c.slice(4); } },
    CA: { name: 'Canada', label: 'Canadian postcode', example: 'K1A 0B1', days: 'intl',
          re: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/,
          format: function (v) { var c = v.replace(/\s/g, ''); return c.slice(0, 3) + ' ' + c.slice(3); } },
    SA: { name: 'Saudi Arabia', label: 'Saudi postcode', example: '11564 or 11564-1234', days: 'intl',
          re: /^\d{5}(?:-?\d{4})?$/ },
    DE: { name: 'Germany', label: 'German postcode', example: '10115', days: 'intl', re: /^\d{5}$/ },
    FR: { name: 'France', label: 'French postcode', example: '75001', days: 'intl', re: /^\d{5}$/ },
    NO: { name: 'Norway', label: 'Norwegian postcode', example: '0150', days: 'intl', re: /^\d{4}$/ }
  };
  function Delivery(root) {
    var w = $(root, '[data-mf-del]'); if (!w) return;
    var input = $(w, '[data-mf-del-input]'), btn = $(w, '[data-mf-del-btn]'), out = $(w, '[data-mf-del-out]');
    var sel = $(w, '[data-mf-del-country]');
    if (!input || !btn || !out || !sel) return;
    var ranges = { uk: w.getAttribute('data-uk').split('-').map(Number), intl: w.getAttribute('data-intl').split('-').map(Number) };

    Object.keys(DELIVERY_COUNTRIES).forEach(function (code) {
      var o = document.createElement('option'); o.value = code; o.textContent = DELIVERY_COUNTRIES[code].name; sel.appendChild(o);
    });
    var saved = lsGet(POST_KEY);
    if (typeof saved === 'string') saved = { country: 'GB', code: saved };              // older saved format
    var startCountry = (saved && DELIVERY_COUNTRIES[saved.country]) ? saved.country
      : (DELIVERY_COUNTRIES[w.getAttribute('data-default-country')] ? w.getAttribute('data-default-country') : 'GB');
    sel.value = startCountry;

    function cfg() { return DELIVERY_COUNTRIES[sel.value] || DELIVERY_COUNTRIES.GB; }
    function placeholder() { input.placeholder = 'e.g. ' + cfg().example.split(' or ')[0]; }
    function day(n) { var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + n); return d; }   // calendar days
    function f(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
    function esc(t) { return t.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function show(html, ok) { out.innerHTML = html; out.className = 'mf-del__out ' + (ok ? 'is-ok' : 'is-err'); }
    function check() {
      var c = cfg();
      var raw = (input.value || '').trim().toUpperCase().replace(/\s+/g, ' ');
      if (!raw) { show('Enter a ' + c.label + ', like ' + esc(c.example) + '.', false); input.focus(); return; }
      var ok = c.test ? c.test(raw) : c.re.test(raw);
      if (!ok) {
        input.setAttribute('aria-invalid', 'true');
        show('Enter a valid ' + c.label + ', like ' + esc(c.example) + '.', false);
        return;
      }
      input.removeAttribute('aria-invalid');
      var label = c.format ? c.format(raw) : raw;
      input.value = label;
      var r = ranges[c.days] || ranges.intl, a = Math.min(r[0], r[1]), b = Math.max(r[0], r[1]);
      show('Delivery by <strong>' + f(day(a)) + ' \u2013 ' + f(day(b)) + '</strong> to ' + esc(label) + ', ' + esc(c.name) +
        '<br><small>' + a + '\u2013' + b + ' calendar days from today, including Sundays and holidays.</small>', true);
      lsSet(POST_KEY, { country: sel.value, code: label });
    }
    sel.addEventListener('change', function () {
      placeholder(); input.removeAttribute('aria-invalid'); out.textContent = ''; out.className = 'mf-del__out';
      lsSet(POST_KEY, { country: sel.value, code: '' });
      if (input.value.trim()) check();
    });
    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    placeholder();
    if (saved && saved.code && saved.country === sel.value) { input.value = saved.code; check(); }
  }

  /* ================= Product: Style + Size (Color hidden), custom pop-up, add-ons, cart hooks ================= */
  function Product(root, gallery) {
    var dataEl = $(root, '[data-mf-pp-data]'); if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = document.getElementById(root.getAttribute('data-form-id'));
    if (!form) return;
    var idInput = $(form, '[data-mf-variant-input]');
    var atcBtns = $$(root, '[data-mf-atc]');
    var priceNow = $(root, '[data-mf-now]'), priceWas = $(root, '[data-mf-was]'), priceOff = $(root, '[data-mf-off]');
    var barPrice = $(root, '[data-mf-bar-price]'), barSize = $(root, '[data-mf-bar-size]');
    var sizeWrap = $(root, '[data-mf-size]'), sizeErr = $(root, '[data-mf-size-error]'), lowEl = $(root, '[data-mf-low]');
    var si = D.sizeIndex, sti = D.styleIndex, hasSize = si > -1, hasStyle = sti > -1;
    var variants = D.variants || [];
    var customKws = (D.customKeywords || ['custom']).map(function (k) { return String(k).trim().toLowerCase(); }).filter(Boolean);
    var customVariant = D.customVariantId ? byId(D.customVariantId) : null;
    var allowCustom = !!D.allowCustom;
    var attempted = false, committed = false;

    function byId(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
    function isCustomV(v) {
      if (!hasSize) return false;
      var val = String(v.options[si] || '').trim().toLowerCase();
      return customKws.some(function (k) { return val.indexOf(k) > -1; });
    }

    /* Visible choices: size + style. Hidden options (Color, ...) keep a "preferred" value
       (from the starting variant) but are wildcards: if the preferred combo is sold out or
       doesn't exist, the first available variant with the chosen Size + Style is used. */
    var first = byId(D.firstId) || variants[0];
    var pref = first ? first.options.slice() : [];
    var size = null, style = hasStyle && first ? first.options[sti] : null;
    var mode = hasSize ? (D.defaultMode === 'standard' || !allowCustom ? 'standard' : null) : null;

    function candidates(sz, st, wantCustom) {
      return variants.filter(function (v) {
        if (hasSize) {
          if (wantCustom) { if (!isCustomV(v)) return false; }
          else if (isCustomV(v)) return false;
          if (sz != null && v.options[si] !== sz) return false;
        }
        if (hasStyle && st != null && v.options[sti] !== st) return false;
        return true;
      });
    }
    function pick(list) {
      var best = null, bestScore = -1;
      list.forEach(function (v) {
        var score = (v.available ? 100 : 0);
        for (var k = 0; k < v.options.length; k++) if (k !== si && k !== sti && v.options[k] === pref[k]) score += 1;
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return best;
    }
    function anyAvailable(list) { return list.some(function (v) { return v.available; }); }

    var pre = D.selectedId ? byId(D.selectedId) : null;
    if (pre) {
      pref = pre.options.slice();
      if (hasStyle) style = pre.options[sti];
      if (hasSize) {
        if (isCustomV(pre) && allowCustom) mode = 'standard';   // custom needs measurements first
        else { size = pre.options[si]; mode = 'standard'; }
      }
    }
    var sizeInputs = $$(root, '[data-mf-size-input]');
    var styleInputs = $$(root, '[data-mf-style-input]');
    var styleSelect = $(root, '[data-mf-style-select]');
    if (hasSize && size == null && sizeInputs.length === 1 && !sizeInputs[0].disabled) size = sizeInputs[0].value;

    function currentVariant() {
      if (!variants.length) return null;
      if (!hasSize) return pick(candidates(null, style, false));
      if (mode === 'custom') {
        if (customVariant) return pick(candidates(null, style, true)) || customVariant;
        return pick(candidates(null, style, false).filter(function (v) { return v.available; }));
      }
      if (mode !== 'standard' || size == null) return null;
      return pick(candidates(size, style, false));
    }

    function fmt(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: D.currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + D.currency; }
    }
    function addonInputs() { return $$(root, '[data-mf-addon]'); }
    function addonTotal() { return addonInputs().reduce(function (t, i) { return t + (i.checked ? parseInt(i.getAttribute('data-price'), 10) || 0 : 0); }, 0); }

    function setButtons(label, disabled) {
      atcBtns.forEach(function (b) {
        if (b.__mfState && b.__mfState !== 'idle') return;
        var span = null;
        for (var i = 0; i < b.children.length; i++) if (b.children[i].tagName === 'SPAN' && !b.children[i].classList.contains('mf-atc-fx')) { span = b.children[i]; break; }
        if (span) span.textContent = label;
        b.disabled = !!disabled;
      });
    }
    function setOos(input, oos) {
      input.disabled = !D.available;                     // whole product sold out: nothing selectable
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-oos', oos || !D.available);
      var sr = label && label.querySelector('[data-mf-sr-oos]');
      if (sr) sr.textContent = (oos || !D.available) ? ' (out of stock)' : '';
    }
    function refreshAvailability() {
      // Style: available if any (non-custom) variant with this style is in stock (for the chosen size, if any)
      styleInputs.forEach(function (inp) {
        var sz = mode === 'standard' ? size : null;
        setOos(inp, !anyAvailable(candidates(sz, inp.value, false)) && !anyAvailable(candidates(null, inp.value, false)));
        inp.checked = inp.value === style;
      });
      if (styleSelect) {
        $$(styleSelect, 'option').forEach(function (o) {
          var ok = anyAvailable(candidates(null, o.value, false));
          o.textContent = o.value + (ok ? '' : ' \u2013 sold out');
        });
        styleSelect.value = style;
      }
      // Size: available if any variant with this size + chosen style is in stock (any Color)
      sizeInputs.forEach(function (inp) {
        var list = candidates(inp.value, style, false);
        var ok = anyAvailable(list);
        setOos(inp, !ok);                                  // a sold-out size stays selected -> Notify Me
        inp.checked = mode === 'standard' && size === inp.value;
        // "Only N left": only when every in-stock variant for this size tracks inventory
        var lab = root.querySelector('label[for="' + inp.id + '"]');
        var low = lab && lab.querySelector('[data-mf-pill-low]');
        if (low) {
          var avail = list.filter(function (v) { return v.available; });
          var tracked = avail.length && avail.every(function (v) { return v.inv != null; });
          var most = tracked ? Math.max.apply(null, avail.map(function (v) { return v.inv; })) : null;
          var show = ok && most != null && most > 0 && most <= D.lowStock;
          low.textContent = show ? 'Only ' + most + ' left' : '';
          lab.classList.toggle('has-low', !!show);
        }
      });
    }
    var qtyIn = $(root, '[data-mf-qty-input]'), qtyMinus = $(root, '[data-mf-qty-minus]'), qtyPlus = $(root, '[data-mf-qty-plus]');
    var qtyMsg = $(root, '[data-mf-qty-msg]');
    function qtyMax(v) { return (v && v.inv != null && v.inv > 0) ? Math.min(v.inv, 99) : 99; }
    function syncQty(v, clampMsg) {
      if (!qtyIn) return;
      var max = qtyMax(v), val = parseInt(qtyIn.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      var clamped = val > max;
      if (clamped) val = max;
      qtyIn.value = val; qtyIn.max = max;
      if (qtyMinus) qtyMinus.disabled = val <= 1;
      if (qtyPlus) qtyPlus.disabled = val >= max;
      if (qtyMsg) {
        if (clamped && clampMsg) { qtyMsg.textContent = 'Only ' + max + ' available in this size.'; qtyMsg.hidden = false; }
        else if (val >= max && max < 99) { qtyMsg.textContent = 'Maximum available: ' + max + '.'; qtyMsg.hidden = false; }
        else qtyMsg.hidden = true;
      }
    }
    if (qtyIn) {
      if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) - 1; syncQty(currentVariant()); });
      if (qtyPlus) qtyPlus.addEventListener('click', function () { qtyIn.value = (parseInt(qtyIn.value, 10) || 1) + 1; syncQty(currentVariant(), true); });
      qtyIn.addEventListener('change', function () { syncQty(currentVariant(), true); });
      qtyIn.addEventListener('blur', function () { syncQty(currentVariant(), true); });
    }

    function update(opts) {
      opts = opts || {};
      refreshAvailability();
      var v = currentVariant();
      var shown = v || pick(candidates(null, style, false)) || first;
      if (idInput && shown) idInput.value = shown.id;
      if (shown && hasSize) pref = shown.options.slice();

      if (shown) {
        var extra = addonTotal(), now = shown.price + extra, hasCmp = shown.compare > shown.price;
        if (priceNow) priceNow.textContent = extra ? fmt(now) : shown.priceF;
        if (priceWas) { priceWas.hidden = !hasCmp; if (hasCmp) priceWas.innerHTML = '<span class="mf-vh">Was </span>' + (extra ? fmt(shown.compare + extra) : shown.compareF); }
        if (priceOff) { priceOff.hidden = !hasCmp; if (hasCmp) priceOff.textContent = '-' + Math.round((shown.compare - shown.price) * 100 / shown.compare) + '% off'; }
        if (barPrice) barPrice.textContent = extra ? fmt(now) : shown.priceF;
      }
      syncQty(v || null, true);
      var oos = !D.available || !!(v && !v.available);
      root.classList.toggle('is-oos', oos);
      root.__mfNotifyInfo = function () {
        var nv = v || (oos ? (pick(candidates(hasSize ? size : null, style, mode === 'custom')) || first) : null);
        var parts = [];
        if (hasStyle && style) parts.push('Style: ' + style);
        if (mode === 'custom') parts.push('Size: Custom');
        else if (hasSize && size) parts.push('Size: ' + size);
        return { variant: nv, label: parts.join(' \u00b7 ') };
      };
      if (!D.available) setButtons('Out of Stock', true);
      else if (v && !v.available) setButtons('Out of Stock', true);
      else setButtons(D.atcLabel || 'Add to cart', false);

      if (lowEl) {
        if (mode === 'standard' && v && v.available && v.inv != null && v.inv > 0 && v.inv <= D.lowStock) {
          lowEl.textContent = v.inv === 1 ? 'Only 1 left in this size' : 'Only ' + v.inv + ' left in this size';
          lowEl.hidden = false;
        } else lowEl.hidden = true;
      }
      var cur = $(root, '[data-mf-style-current]'); if (cur && style) cur.textContent = style;
      if (barSize) barSize.textContent = mode === 'custom' ? 'Custom size' : (hasSize && size ? 'Size ' + size : '');
      if (modeBtns && !D.available) modeBtns.forEach(function (b) { b.disabled = true; });
      if (opts.media && shown && shown.media) gallery.goToMedia(shown.media);
      if (opts.url && v && mode === 'standard' && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
      if (sizeErr && !sizeErr.hidden && ((mode === 'standard' && size) || (mode === 'custom' && committed))) sizeErr.hidden = true;
    }

    styleInputs.forEach(function (inp) { inp.addEventListener('change', function () { if (inp.checked) { style = inp.value; update({ media: true, url: true }); } }); });
    if (styleSelect) styleSelect.addEventListener('change', function () { style = styleSelect.value; update({ media: true, url: true }); });
    sizeInputs.forEach(function (inp) { inp.addEventListener('change', function () { if (inp.checked) { size = inp.value; update({ media: true, url: true }); } }); });

    /* ---------- Modes + custom-size pop-up ---------- */
    var modeBtns = $$(root, '[data-mf-mode]');
    var stdPanel = $(root, '[data-mf-panel="standard"]');
    var summary = $(root, '[data-mf-cus-summary]'), summaryText = $(root, '[data-mf-cus-summary-text]');
    var cusDlg = $(root, '[data-mf-sheet="custom"]');
    var cusErr = cusDlg ? $(cusDlg, '[data-mf-cus-err]') : null;
    var mInputs = cusDlg ? $$(cusDlg, '[data-mf-m]') : [];
    var cusSheet = Sheet(cusDlg, {
      // On phones focus the close button (no keyboard jumping up over the form); on desktop the first field.
      focus: function () {
        var bad = mInputs.filter(function (i) { return i.getAttribute('aria-invalid') === 'true'; })[0];
        if (bad) return bad;
        return window.matchMedia('(pointer: coarse)').matches ? $(cusDlg, '.mf-sheet__x') : mInputs[0];
      }
    });

    function renderMode() {
      modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mf-mode') === mode ? 'true' : 'false'); });
      if (stdPanel && allowCustom) stdPanel.hidden = mode === 'custom';
      if (summary) summary.hidden = !(mode === 'custom' && committed);
    }
    function setMode(m) { mode = m; renderMode(); update({ media: m === 'standard', url: m === 'standard' }); }
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('data-mf-mode') === 'custom') { if (cusErr) cusErr.hidden = true; cusSheet.open(b); }
        else setMode('standard');
      });
    });
    var editBtn = $(root, '[data-mf-cus-edit]');
    if (editBtn) editBtn.addEventListener('click', function () { cusSheet.open(editBtn); });

    var unit = 'in', fit = 'Regular', lining = 'No';
    var noteEl = cusDlg ? $(cusDlg, '[data-mf-note]') : null, saveEl = cusDlg ? $(cusDlg, '[data-mf-save]') : null;
    var statusEl = cusDlg ? $(cusDlg, '[data-mf-save-status]') : null;
    function range(inp) {
      var mn = parseFloat(inp.getAttribute('data-min-in')), mx = parseFloat(inp.getAttribute('data-max-in'));
      return unit === 'cm' ? [Math.round(mn * 2.54), Math.round(mx * 2.54)] : [mn, mx];
    }
    function errEl(inp) { return document.getElementById(inp.getAttribute('aria-describedby')); }
    function validateField(inp, show) {
      var label = inp.getAttribute('data-label'), raw = String(inp.value).trim(), msg = '';
      var r = range(inp), val = parseFloat(raw.replace(',', '.'));
      if (!raw) { if (inp.hasAttribute('data-required')) msg = 'Enter your ' + label.toLowerCase(); }
      else if (isNaN(val)) msg = 'Use numbers only';
      else if (val < r[0] || val > r[1]) msg = 'Usually ' + r[0] + '\u2013' + r[1] + ' ' + unit;
      if (show) {
        var e = errEl(inp);
        if (msg) { inp.setAttribute('aria-invalid', 'true'); if (e) { e.textContent = msg; e.hidden = false; } }
        else { inp.removeAttribute('aria-invalid'); if (e) { e.textContent = ''; e.hidden = true; } }
      }
      return msg;
    }
    function validateCustom(show) {
      var bad = null;
      mInputs.forEach(function (inp) { if (validateField(inp, show) && !bad) bad = inp; });
      return bad;
    }
    function setSeg(attr, value) { $$(cusDlg, '[' + attr + ']').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute(attr) === value ? 'true' : 'false'); }); }
    function setUnit(u, convert) {
      if (u === unit) return;
      if (convert) mInputs.forEach(function (inp) {
        var v = parseFloat(String(inp.value).replace(',', '.'));
        if (!isNaN(v)) inp.value = u === 'cm' ? (Math.round(v * 2.54 * 2) / 2) : (Math.round(v / 2.54 * 4) / 4);
      });
      unit = u; setSeg('data-mf-unit-btn', u);
      $$(cusDlg, '[data-mf-unit]').forEach(function (s) { s.textContent = u; });
      mInputs.forEach(function (inp) { inp.step = u === 'cm' ? '0.5' : '0.25'; if (attempted || inp.hasAttribute('aria-invalid')) validateField(inp, true); });
      persist(); renderSummary();
    }
    function snapshot() {
      var vals = {};
      mInputs.forEach(function (inp) { if (String(inp.value).trim() !== '') vals[inp.getAttribute('data-mf-m')] = inp.value; });
      return { unit: unit, fit: fit, lining: lining, vals: vals };
    }
    function persist() { if (saveEl && saveEl.checked && lsSet(STORE_KEY, snapshot()) && statusEl) statusEl.textContent = 'Saved on this device'; }
    var persistT;
    function persistSoon() { clearTimeout(persistT); persistT = setTimeout(persist, 400); }
    function renderSummary() {
      if (!summaryText) return;
      var parts = [];
      ['bust', 'waist', 'hips', 'shoulder'].forEach(function (k) {
        var inp = mInputs.filter(function (i) { return i.getAttribute('data-mf-m') === k; })[0];
        if (inp && String(inp.value).trim()) parts.push(inp.getAttribute('data-label') + ' ' + inp.value);
      });
      summaryText.textContent = 'Custom (' + unit + ', ' + fit.toLowerCase() + '): ' + parts.join(', ') + '\u2026';
    }

    if (cusDlg) {
      $$(cusDlg, '[data-mf-unit-btn]').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.getAttribute('data-mf-unit-btn'), true); }); });
      $$(cusDlg, '[data-mf-fit-btn]').forEach(function (b) { b.addEventListener('click', function () { fit = b.getAttribute('data-mf-fit-btn'); setSeg('data-mf-fit-btn', fit); persist(); }); });
      $$(cusDlg, '[data-mf-lining-btn]').forEach(function (b) { b.addEventListener('click', function () { lining = b.getAttribute('data-mf-lining-btn'); setSeg('data-mf-lining-btn', lining); persist(); }); });
      $$(cusDlg, '.mf-seg').forEach(function (g) {
        g.addEventListener('keydown', function (e) {
          if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
          var bs = $$(g, '.mf-seg__btn'), i = bs.indexOf(document.activeElement); if (i < 0) return;
          e.preventDefault();
          var n = bs[(i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1) + bs.length) % bs.length];
          n.focus(); n.click();
        });
      });
      mInputs.forEach(function (inp) {
        inp.addEventListener('blur', function () { if (String(inp.value).trim() !== '' || attempted) validateField(inp, true); });
        inp.addEventListener('input', function () { if (inp.hasAttribute('aria-invalid')) validateField(inp, true); persistSoon(); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); saveBtn && saveBtn.click(); } });
      });
      if (saveEl) saveEl.addEventListener('change', function () {
        if (saveEl.checked) persist();
        else { lsDel(STORE_KEY); if (statusEl) statusEl.textContent = 'Not saved on this device'; }
      });
      var clearBtn = $(cusDlg, '[data-mf-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () {
        lsDel(STORE_KEY);
        mInputs.forEach(function (inp) { inp.value = ''; inp.removeAttribute('aria-invalid'); var e = errEl(inp); if (e) e.hidden = true; });
        if (saveEl) saveEl.checked = false;
        if (statusEl) statusEl.textContent = 'Saved measurements cleared';
        if (committed) { committed = false; setMode('standard'); }
      });
      var saveBtn = $(cusDlg, '[data-mf-cus-save]');
      saveBtn.addEventListener('click', function () {
        attempted = true;
        var bad = validateCustom(true);
        if (bad) {
          if (cusErr) { cusErr.textContent = 'Please check the fields marked in red.'; cusErr.hidden = false; }
          bad.focus();
          return;
        }
        if (cusErr) cusErr.hidden = true;
        committed = true;
        persist(); renderSummary();
        setMode('custom');
        cusSheet.close();
      });
      (function prefill() {
        var saved = lsGet(STORE_KEY);
        if (!saved || !mInputs.length) return;
        if (saved.unit === 'cm') setUnit('cm', false);
        if (saved.fit) { fit = saved.fit; setSeg('data-mf-fit-btn', fit); }
        if (saved.lining) { lining = saved.lining; setSeg('data-mf-lining-btn', lining); }
        mInputs.forEach(function (inp) { var k = inp.getAttribute('data-mf-m'); if (saved.vals && saved.vals[k] != null) inp.value = saved.vals[k]; });
        if (saveEl) saveEl.checked = true;
        if (statusEl) statusEl.textContent = 'Your saved measurements are filled in';
      })();
    }

    function customProps() {
      var p = { 'Size': 'Custom', 'Units': unit === 'cm' ? 'Centimetres' : 'Inches', 'Fit': fit };
      mInputs.forEach(function (inp) { var v = String(inp.value).trim(); if (v !== '') p[inp.getAttribute('data-label')] = v + ' ' + unit; });
      p['Sleeve lining'] = lining;
      var note = noteEl ? noteEl.value.trim() : '';
      if (note) p['Note'] = note.slice(0, 300);
      if (!customVariant) p['_Custom size base variant'] = 'yes';
      return p;
    }

    addonInputs().forEach(function (i) { i.addEventListener('change', function () { update(); }); });

    /* ---------- validation + cart payload (called by the header add-to-cart flow) ---------- */
    function sizeError(msg, focusEl) {
      if (sizeErr) { sizeErr.textContent = msg; sizeErr.hidden = false; }
      if (sizeWrap) {
        sizeWrap.classList.remove('is-attn'); void sizeWrap.offsetWidth; sizeWrap.classList.add('is-attn');
        if (!inView(sizeWrap)) sizeWrap.scrollIntoView({ behavior: behavior(), block: 'center' });
      }
      if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, RM.matches ? 0 : 350);
      return msg;
    }
    form.mfValidate = function () {
      attempted = true;
      if (sizeErr) sizeErr.hidden = true;
      if (!D.available) return 'This product is out of stock.';
      if (hasSize) {
        if (!mode) return sizeError('Please choose Standard Size or Custom Size.', modeBtns[0]);
        if (mode === 'standard' && size == null) {
          return sizeError('Please select your size.', sizeInputs.filter(function (i) { return !i.disabled; })[0]);
        }
        if (mode === 'custom') {
          var bad = validateCustom(true);
          if (!committed || bad) {
            cusSheet.open(modeBtns[1]);
            return sizeError('Please complete and save your custom measurements.', null);
          }
          if (!currentVariant()) return sizeError('Custom size is not available for this option.', null);
        }
      }
      var v = currentVariant();
      if (!v) return 'This combination is unavailable. Please choose another option.';
      if (!v.available) return 'This size is out of stock.';
      if (idInput) idInput.value = v.id;
      return '';
    };
    form.mfPrepare = function (fd) {
      var v = currentVariant(); if (!v) return fd;
      if (MOBILE.matches) fd.set('quantity', '1');        // mobile: no quantity selector, 1 per tap
      var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      var props = {}, hasFile = false;
      fd.forEach(function (val, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (!m) return;
        if (typeof val !== 'string') { hasFile = true; return; }
        if (val !== '') props[m[1]] = val;
      });
      if (mode === 'custom') { var cp = customProps(); for (var k in cp) props[k] = cp[k]; persist(); }
      var adds = addonInputs().filter(function (i) { return i.checked; });
      fd.set('id', String(v.id));
      if (hasFile) {
        if (mode === 'custom') { var c2 = customProps(); for (var k2 in c2) fd.set('properties[' + k2 + ']', c2[k2]); }
        return fd;
      }
      if (!adds.length && mode !== 'custom') return fd;
      var main = { id: v.id, quantity: qty };
      // hidden group id links the outfit and its add-ons, so the cart can show add-ons under the outfit
      var grp = adds.length ? 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) : '';
      if (grp) props._mf_group = grp;
      if (Object.keys(props).length) main.properties = props;
      var sp = fd.get('selling_plan'); if (sp) main.selling_plan = parseInt(sp, 10);
      var label = D.title + (mode === 'custom' ? ' (Custom size)' : (hasSize && size ? ' \u2013 ' + size : '')) + (hasStyle && style ? ' / ' + style : '');
      var items = [main];
      adds.forEach(function (a) { items.push({ id: parseInt(a.value, 10), quantity: qty, properties: { 'Add-on for': label, _mf_group: grp } }); });
      return { items: items };
    };

    renderMode();
    update({ media: !!D.selectedId });
  }

  /* ================= Sticky bar ================= */
  // One Add to Cart on screen: the bar shows only while the inline button is out of view.
  function StickyBar(root) {
    var bar = $(root, '[data-mf-bar]'); if (!bar) return;
    var main = $(root, '.mf-pp__form [data-mf-atc]');
    var sticky = $(bar, '[data-mf-atc]');
    var mainVisible = true;
    function apply() {
      var on = MOBILE.matches ? true : !mainVisible;   // mobile: the bar is the only Add to Cart
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (sticky) sticky.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('mf-pp-bar-on', on && MOBILE.matches);
      if (on && MOBILE.matches) document.body.style.setProperty('--bar-h', bar.offsetHeight + 'px');
    }
    if (main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { mainVisible = e.isIntersecting; });
        apply();
      }, { rootMargin: '0px 0px -' + (MOBILE.matches ? 70 : 0) + 'px 0px' }).observe(main);
    } else { mainVisible = false; }
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', apply);
    apply();
    if (main && sticky) mirrorButtons(main, sticky);
  }

  // Keep both buttons in the same state (loading / Added / error shake / Out of Stock / label),
  // whichever one the shopper pressed. The header animates the pressed one; we copy it.
  var STATES = ['is-loading', 'is-success', 'is-error', 'mf-atc'];
  function mirrorButtons(a, b) {
    var syncing = false;
    function labelSpan(btn) {
      for (var i = 0; i < btn.children.length; i++) {
        var c = btn.children[i];
        if (c.tagName === 'SPAN' && !c.classList.contains('mf-atc-fx')) return c;
      }
      return null;
    }
    function copy(from, to) {
      if (syncing) return; syncing = true;
      var fx = from.querySelector(':scope > .mf-atc-fx');
      if (fx && !to.querySelector(':scope > .mf-atc-fx')) {
        var c = fx.cloneNode(true); to.appendChild(c); to.__mfFx = c;
      }
      STATES.forEach(function (cl) { to.classList.toggle(cl, from.classList.contains(cl)); });
      if (to.disabled !== from.disabled) to.disabled = from.disabled;           // only write on change (no observer ping-pong)
      var busy = from.hasAttribute('aria-busy');
      if (busy && !to.hasAttribute('aria-busy')) to.setAttribute('aria-busy', 'true');
      else if (!busy && to.hasAttribute('aria-busy')) to.removeAttribute('aria-busy');
      to.__mfState = from.__mfState; to.__mfWasDisabled = from.__mfWasDisabled;
      var fl = labelSpan(from), tl = labelSpan(to);
      if (fl && tl && tl.textContent !== fl.textContent) tl.textContent = fl.textContent;
      syncing = false;
    }
    [a, b].forEach(function (btn) {
      var other = btn === a ? b : a;
      new MutationObserver(function () { copy(btn, other); })
        .observe(btn, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-busy'], childList: true, characterData: true, subtree: true });
    });
  }

  /* ================= Notify Me (sold out) =================
     Klaviyo Back in Stock when a Klaviyo public key is set; otherwise Shopify's contact form,
     which emails your store with the product, variant, link and the customer's details. */
  var NOTIFY_KEY = 'mf_notify_email';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function Notify(root, D) {
    var dlg = $(root, '[data-mf-sheet="notify"]'); if (!dlg) return;
    var formEl = $(dlg, '.mf-notify__form'), done = $(dlg, '[data-mf-notify-done]');
    var email = $(dlg, '[data-mf-notify-email]'), phone = $(dlg, '[data-mf-notify-phone]');
    var err = $(dlg, '[data-mf-notify-err]'), formErr = $(dlg, '[data-mf-notify-formerr]');
    var submit = $(dlg, '[data-mf-notify-submit]'), varLine = $(dlg, '[data-mf-notify-variant]');
    var vTitle = $(dlg, '[data-mf-notify-vtitle]'), vId = $(dlg, '[data-mf-notify-vid]'), body = $(dlg, '[data-mf-notify-body]');
    var klaviyoKey = (dlg.getAttribute('data-klaviyo-key') || '').trim();
    var info = { variant: null, label: '' };
    var sheet = Sheet(dlg, { focus: function () { return email.value ? submit : email; } });

    function fill() {
      info = (root.__mfNotifyInfo && root.__mfNotifyInfo()) || { variant: null, label: '' };
      varLine.textContent = info.label || '';
      varLine.hidden = !info.label;
      var v = info.variant;
      vTitle.value = info.label || (v ? 'Variant ' + v.id : 'Any size');
      vId.value = v ? String(v.id) : '';
      try { var saved = localStorage.getItem(NOTIFY_KEY); if (saved && !email.value) email.value = saved; } catch (e) {}
      formEl.hidden = false; done.hidden = true; err.hidden = true; formErr.hidden = true;
      email.removeAttribute('aria-invalid');
    }
    $$(root, '[data-mf-notify-open]').forEach(function (b) {
      b.addEventListener('click', function () { fill(); sheet.open(b); });
    });
    function showDone() {
      formEl.hidden = true; done.hidden = false;
      var de = $(done, '[data-mf-notify-done-email]'); if (de) de.textContent = 'We\u2019ll email ' + email.value.trim() + '.';
      done.focus({ preventScroll: true });
    }
    function fail(msg) { formErr.textContent = msg; formErr.hidden = false; submit.disabled = false; submit.classList.remove('is-loading'); }

    function viaKlaviyo(addr, tel) {
      var v = info.variant;
      if (!v) return Promise.reject(new Error('no variant'));
      var profile = { email: addr };
      if (tel) profile.phone_number = tel;
      return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: profile } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } })
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
    }
    function viaContact() {
      var fd = new FormData(formEl);
      return fetch(formEl.action, { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (/challenge/.test(r.url)) { formEl.submit(); return new Promise(function () {}); }   // Shopify spam check: let the page handle it
          if (!r.ok) throw new Error('contact ' + r.status);
          return r.text().then(function (html) {
            if (/contact_posted=true|form_type=contact|posted_successfully/i.test(r.url + html)) return;
            if (/class="[^"]*errors/i.test(html)) throw new Error('contact errors');
          });
        });
    }

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var addr = email.value.trim(), tel = phone ? phone.value.trim() : '';
      if (!EMAIL_RE.test(addr)) {
        err.textContent = addr ? 'Enter a valid email, like name@example.com' : 'Enter your email address';
        err.hidden = false; email.setAttribute('aria-invalid', 'true'); email.focus(); return;
      }
      err.hidden = true; email.removeAttribute('aria-invalid'); formErr.hidden = true;
      body.value = 'Back in stock request\nProduct: ' + D.title + '\nVariant: ' + (vTitle.value || '-') +
        ' (ID ' + (vId.value || '-') + ')\nLink: ' + D.url + (vId.value ? '?variant=' + vId.value : '') +
        '\nEmail: ' + addr + (tel ? '\nPhone/WhatsApp: ' + tel : '');
      try { localStorage.setItem(NOTIFY_KEY, addr); } catch (e2) {}
      submit.disabled = true; submit.classList.add('is-loading');
      var p = klaviyoKey ? viaKlaviyo(addr, tel).catch(function () { return viaContact(); }) : viaContact();
      p.then(function () { submit.disabled = false; submit.classList.remove('is-loading'); showDone(); })
       .catch(function () { fail('That didn\u2019t go through. Check your connection and try again.'); });
    });
    email.addEventListener('input', function () { if (email.getAttribute('aria-invalid')) { err.hidden = true; email.removeAttribute('aria-invalid'); } });
  }

  /* ================= Init ================= */
  function init(scope) {
    $$(scope || document, '[data-mf-pp]').forEach(function (root) {
      if (root.__mfInit) return; root.__mfInit = true;
      var D = {}; try { D = JSON.parse($(root, '[data-mf-pp-data]').textContent); } catch (e) {}
      var open = Lightbox(root);
      var gallery = Gallery(root, open);
      Offers(root);
      Wishlist(root, D);
      Share(root, D);
      Reviews(root, root.getAttribute('data-reviews-target') || '#judgeme_product_reviews, .jdgm-review-widget');
      SizeChart(root);
      Delivery(root);
      Product(root, gallery);
      Notify(root, D);
      StickyBar(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { document.body.classList.remove('mf-pp-bar-on'); document.documentElement.classList.remove('mf-scroll-lock'); init(e.target); });
  document.addEventListener('shopify:section:unload', function () { document.body.classList.remove('mf-pp-bar-on'); document.documentElement.classList.remove('mf-scroll-lock'); });
})();